import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import DepartmentImgNotFound from "./../../assets/images/department-not-found.svg";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import { ReactComponent as EditIcon } from "./../../assets/images/icons/Google SVGs/edit.svg";

const DepartmentCard = (props) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //   const removeDepartmentAPI = () => {
  //     setLoading(true);
  //     axios
  //       .post(
  //         serverConfig.server.url + apiConfig.api.deleteAPIs.deleteDepartmentPlace,
  //         {
  //           place_id: props.placeId,
  //           department_id: props.departmentId,
  //         },
  //         {
  //           headers,
  //         }
  //       )
  //       .then((response) => {
  //         setLoading(false);
  //         if (response.data.status === "success") {
  //           toast.success(response.data.message);
  //           props.onSuccess();
  //         } else {
  //           if (typeof response.data.errors === typeof "String") {
  //             toast.error(response.data.errors);
  //           } else {
  //             response.data.errors.forEach((element) => {
  //               toast.error(element);
  //             });
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         toast.error("Error making API call:", error);
  //       });
  //   };

  return (
    <div className="w-100">
      <div className="card border-0 background-bootstrap-gray-100 border-radius-8 tw-cursor-pointer">
        <div className="card-body d-flex flex-row justify-content-between p-2 py-1 fs-14 fw-regular bg-transparent">

          <div className="d-flex">

            <div className="d-flex color-iso-gray-600 fs-12">
              <img
                className="me-1 doctor-image-box p-1"
                src={props.files ? props.files : DepartmentImgNotFound}
              />
            </div>

            <div className="d-flex color-iso-gray-600 fs-14 align-items-center">
              <span className="me-1 ms-2">{props.departmentTitle}</span>
            </div>

          </div>

          {props.departmentId && props.edit && haveAccess(roles, "department_card_edit") &&
            (
              <div className="col-auto d-flex align-items-center">
                <div
                  type="button"
                  className="me-1"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(
                      `/department-store?${"dep=" + props.departmentId}`
                    );
                  }}
                >
                  <IconButton type="button">
                    <EditIcon width={24} className="me-1" />
                  </IconButton>
                </div>
              </div>
            )}

          {
            !props.is_sub ?
              <div className="tw-flex tw-items-center tw-rotate-90 tw-ml-2 tw-justify-center">
                <img src="./keyboard_arrow_down.png" alt="keyboard_arrow_down.png" />
              </div>
              : null
          }
        </div>
      </div>
    </div>
  );
};

export default DepartmentCard;
